var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMdsiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.399 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons_v1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.971,8.407A13.335,13.335,0,0,0,5.455,24.651,24.288,24.288,0,0,1,16.966,12.911l-6.9.038Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.319,37.723l-.9-.771A17.463,17.463,0,0,1,2.3,28.065a15.249,15.249,0,0,1-1.26-2.6L0,25.21A18.99,18.99,0,0,0,21.319,37.723"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.786,31.242a13.336,13.336,0,0,0,16.326-4.21,24.287,24.287,0,0,1-15.923-4.1l3.481,5.954Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.643,25.385A18.3,18.3,0,0,0,20.652,37.192,33.439,33.439,0,0,1,9.123,17.626L6.7,26.867Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.153,17.386A13.334,13.334,0,0,0,19.345,5.353a24.3,24.3,0,0,1,4.412,15.839L27.171,15.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.128,30.788a18.3,18.3,0,0,0,.22-23.232,33.443,33.443,0,0,1-11.18,19.766L30.382,24.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.639,28.9a24.531,24.531,0,0,0,6.554,5.886,30.32,30.32,0,0,0,6.252,2.99l.16-.419A29.819,29.819,0,0,1,14.43,34.4,24.053,24.053,0,0,1,8,28.632a16.353,16.353,0,0,1-3.276-8.658,13.932,13.932,0,0,1,1.62-7.287,12.447,12.447,0,0,1,1.2-1.9l.215-.243s-.291.042-.382.058l-.3.049a19.449,19.449,0,0,0-1.13,1.828,14.412,14.412,0,0,0-1.671,7.537A16.779,16.779,0,0,0,7.639,28.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.316,37.719s-.357-.114-.7-.262-1.3-.561-1.554-.673.14-.219.14-.219l.726.026a1.015,1.015,0,0,1,.287.19C20.378,36.923,21.316,37.719,21.316,37.719Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.693,23.016a24.538,24.538,0,0,0,1.82-8.619,30.258,30.258,0,0,0-.537-6.909l-.442.07a29.82,29.82,0,0,1,.531,6.824,24.053,24.053,0,0,1-1.782,8.453A16.36,16.36,0,0,1,25.423,30,13.937,13.937,0,0,1,18.3,32.24a12.556,12.556,0,0,1-2.248-.087l-.318-.066s.181.232.241.3.191.232.191.232a19.333,19.333,0,0,0,2.148.065,14.418,14.418,0,0,0,7.363-2.321A16.785,16.785,0,0,0,31.693,23.016Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.092,12.557A18.989,18.989,0,0,1,21.588.35l-.734.772A15.325,15.325,0,0,0,17.968.911,17.465,17.465,0,0,0,1.208,12.165l-1.116.392"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.089.864A18.3,18.3,0,0,0,.859,12.289a33.431,33.431,0,0,1,22.709-.2L16.776,5.369Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.575,5.125A24.525,24.525,0,0,0,6.2,7.858a30.292,30.292,0,0,0-5.715,3.92l.282.348A29.793,29.793,0,0,1,6.411,8.254a24.047,24.047,0,0,1,8.211-2.683,16.353,16.353,0,0,1,9.136,1.492,13.938,13.938,0,0,1,5.5,5.045,12.517,12.517,0,0,1,1.049,1.99l.1.307s.109-.272.142-.36.106-.281.106-.281a19.507,19.507,0,0,0-1.018-1.893,14.41,14.41,0,0,0-5.692-5.215A16.781,16.781,0,0,0,14.575,5.125Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.1,12.559s.277-.252.577-.474,1.137-.847,1.359-1.009.12.23.12.23l-.385.616a1.022,1.022,0,0,1-.308.154C1.254,12.145.1,12.559.1,12.559Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdsiIcon);
export default __webpack_public_path__ + "static/media/mdsi-icon.01361cbdfb9f03d684344a19307a13c5.svg";
export { ForwardRef as ReactComponent };